import React from 'react'
import PropTypes from 'prop-types'

class ListItemIcon extends React.Component {
  render() {
    //const { model, sitename, uptime } = this.props
    return (
      <li className='list-group-item'>
        <img width='64' src='/images/solar-icon.jpg' class='img-responsive' alt=''/>
        <div>
          <h4 className="list-group-item-heading">Boryung</h4>
          <p className="list-group-item-text text-sm">SITE NAME</p>
        </div>
      </li>
    )
  }
}

ListItemIcon.propTypes = {
  strings: PropTypes.object
}

ListItemIcon.defaultProps = {
  strings: {
  }
}

export default ListItemIcon



// WEBPACK FOOTER //
// ./src/components/widgets/ListItemIcon.js